import { render, staticRenderFns } from "./project-detail-history-income.vue?vue&type=template&id=3b5814f4&"
import script from "./project-detail-history-income.vue?vue&type=script&lang=js&"
export * from "./project-detail-history-income.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports